export default __webpack_public_path__ + "static/media/python.ecfb4e6f.png";